import { HiOutlineHome } from "react-icons/hi";                 
import { LuClipboardList } from "react-icons/lu";                
import { FiTruck } from "react-icons/fi";                       
import { HiOutlineDocumentReport } from "react-icons/hi";
import { MdOutlineOutbox } from "react-icons/md";
import { LuBarChart2 } from "react-icons/lu";                
import { LuMapPin } from "react-icons/lu";                     
import { LuPackage } from "react-icons/lu";                    
import { HiOutlineCalendar } from "react-icons/hi";            
import { LuSettings } from "react-icons/lu";          
import { LuLayoutDashboard } from "react-icons/lu";             
import { HiOutlineLogout } from "react-icons/hi";  

const icon_sidebar_helper = (name: string) => {
  const icons: any = {
    home: HiOutlineHome,
    orders: LuClipboardList,
    logistic: FiTruck,
    inventory: LuPackage,
    calendar: HiOutlineCalendar,
    reports: HiOutlineDocumentReport,
    bulk: MdOutlineOutbox,
    areas: LuMapPin,
    business: LuBarChart2,
    settings: LuSettings,
    logout: HiOutlineLogout,
  }
  return icons.hasOwnProperty(name) ? icons[name] : LuLayoutDashboard
}

export default icon_sidebar_helper
